module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step.kind === 'multiple-choice') ? _c('div', {
    staticClass: "klickbox-edit-code"
  }, [_c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label label__checkbox"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.multiple_answers')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.multiple_answers
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateMultipleAnswers({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label label__checkbox"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.add_other_option')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.optionOtherAnswer
    },
    on: {
      "change": function($event) {
        return _vm.optionUpdateOtherAnswer({
          event: $event
        })
      }
    }
  }), _c('span')])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-196a5658!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/config/MultipleChoice.vue
 ** module id = 773
 ** module chunks = 1
 **/